import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import PageHead from "../components/common/PageHead";

import TopAd from "../images/premium-quality.png";

import "../styles/disable-profile.css";

class FeaturedAdd extends Component {
  state = {
    lng: true,
  };

  componentDidMount = () => {
    // scroll to top
    document.body.scrollTop = 0;
    // lng
    this.setState({
      lng: localStorage.getItem("lng")
        ? localStorage.getItem("lng") === "true"
          ? true
          : false
        : true,
    });
  };

  handleLng = () => {
    this.setState({ lng: !this.state.lng });
    localStorage.setItem("lng", !this.state.lng);
  };

  handleBack = () => {
    this.props.history.push('/settings');
  };

  render() {
    return (
      <React.Fragment>
        <PageHead title={this.props.title} />
        <Navbar handleLng={this.handleLng} lng={this.state.lng} />
        <Grid
          container
          xs={12}
          sm={10}
          md={8}
          direction="column"
          className="cus-container"
        >
          <div className="disable-div">
            <p className="message">
              {this.state.lng ? "Your Ad Is Already a Boosted Ad!" : "ඔබේ දැන්වීම දැනටමත් විශේෂාංගගත කර ඇත!"}
            </p>
            <p align="center" style={{ marginBottom: 0 }}>
              <img src={TopAd} alt="info" style={{ width: 100, opacity: 0.7 }} />
            </p>

            <Button
              variant="contained"
              onClick={this.handleBack}
              className="login-btn"
              style={{ width: 'fit-content' }}
            >
              {this.state.lng ? (
                "Go Back"
              ) : (
                <span className="sinhala-w-600 sinhala-size-14">
                  ආපසු යන්න
                </span>
              )}
            </Button>
          </div>
        </Grid>
        <Footer lng={this.state.lng} />
      </React.Fragment>
    );
  }
}

export default withRouter(FeaturedAdd);
